import { makeRoute } from '~/utils/route';

export default makeRoute({
	path: '/',
	name: 'home',
	template: '<home></home>',
	title:       'common.home',
	reloadOnUrl: false,
});
